import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './MyAppointments.css';

/**
 *  AppointmentCard imported
 */
import AppointmentCard from './AppointmentCard/AppointmentCard';

const cx = classNames.bind(styles);

const cardRender = (item, hrefMap, messagesTexts, isExternalLinks, onCardClick) => {
    const href = get(hrefMap, item.name, '');
    const details = {
        ...item,
        href,
    };
    const cardProps = {
        details,
        messagesTexts,
        openInNewTab: isExternalLinks,
        onCardClick,
    };
    return (
        <li key={uniqueId('appointment_')}>
            <AppointmentCard
                /* eslint-disable react/jsx-props-no-spreading */
                {...cardProps}
            />
        </li>
    );
};

/**
 * <MyAppointments /> component to display schedule appointment
 * @param {object} props - Component Props.
 */
const MyAppointments = ({ list, hrefMap, messagesTexts, isExternalLinks, onCardClick }) => {
    if (isEmpty(list)) return null;

    return (
        <section className={`${cx('myAppointmentsWrapper')} ${dt(['w-full'])}`}>
            <ul
                className={`${cx('appointment-list')} ${dt([
                    'flex',
                    'flex-col',
                    'items-center',
                    'mdOnly:m-0',
                    'items-stretch',
                ])}`}
            >
                {list.map((item) =>
                    cardRender(item, hrefMap, messagesTexts, isExternalLinks, onCardClick)
                )}
            </ul>
        </section>
    );
};

MyAppointments.propTypes = {
    /**
     *  "list" has collection of appointments to display
     */
    list: PropTypes.oneOfType([PropTypes.array]),
    /**
     *  "hrefMap" has all urls of appointment list from api
     */
    hrefMap: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    /**
     *  "messagesTexts" contains all labels specific to AppointmentCard
     */
    messagesTexts: PropTypes.oneOfType([PropTypes.object]),
    /**
     *  "isExternalLinks" to configure link to open in new tab
     */
    isExternalLinks: PropTypes.bool,

    onCardClick: PropTypes.func,
};

MyAppointments.defaultProps = {
    messagesTexts: {},
    list: [],
    isExternalLinks: true,
    onCardClick: noop,
};

export default MyAppointments;
